import gql from 'graphql-tag';

import dokkioUserFragment from './dokkioUserFragment';

export const dokkioUsersPageFragment = gql`
  fragment dokkioUsersPageFragment on DokkioUsersPage {
    dokkioClass
    total
    dokkioUsers {
      ...dokkioUserFragment
    }
  }
  ${dokkioUserFragment}
`;
export default dokkioUsersPageFragment;
